import { render, staticRenderFns } from "./IntegrationRecords.vue?vue&type=template&id=00b769ac&"
import script from "./IntegrationRecords.vue?vue&type=script&lang=js&"
export * from "./IntegrationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports